module.exports = __webpack_public_path__ + "static/media/editar_branco.635160a4.svg";